/* eslint-disable */
import React, { useState } from 'react';
import {
  PageHeader, Col, Row, Space, Button, Tooltip, Typography, Result
} from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import Breadcrumb from 'components/BreadCrumb';
import Specifications from 'containers/specifications/form';
import OtherSpecifications from 'containers/specifications/form/other';
import FinalSpecification from 'containers/specifications/final';
import DownLoadPDF from 'components/pdf/download';
import { getCodesWithMessage } from 'utils/codes';
import { sendSpecification } from 'utils/mails';
import ModalForm from 'containers/mailing/ModalFrom';
import SendCDC from 'containers/mailing/SendCDC';
import CostingForm from 'containers/costing/form';

const {
  Title, Paragraph, Text
} = Typography;

export const officialTextsHead = () => (
  <Typography>
    <Title
      style={{ textAlign: 'center', marginTop: '20px' }}
      level={2}
    >
      Cahier des charges achat matériaux en contact
      {' '}
      <br />
      {' '}
      avec des denrées alimentaires.
    </Title>
  </Typography>
);

export const getCodeHtml = (recipe) => {
  const { message, codes } = getCodesWithMessage(recipe);
  if (!codes) return false;
  return (
    <Row>
      <ul style={{ marginTop: '20px' }}>
        {codes.map(code => (
          <li>
            {code}
          </li>
        )
        )}
        {message && message !== '' && (
          <li style={{ color: 'orange', listStyle: 'outside' }}>{message}</li>
        )}
      </ul>
    </Row>
  );
};

export const SIMULANTS_LIST_TEXT = 'Liste des simulants affectés à la recette: ';

export const OFFICIALTEXTSCONTENT = 'Les matériaux et matériels en contact les denrées alimentaires, pour respecter l’article 16 du a\n'
  + 'règlement CE N° 1935/2004, doivent pouvoir attester de test de migration conforme pour les\n'
  + 'simulants suivants :\n'
  + '\n';

const SpecificationFlow = (props) => {
  const { recipe, history: { replace }, setSpecifications } = props;
  const { name } = recipe || 'sans nom';
  const [customRecipeName, setCustomRecipeName] = useState(name);
  const [detailsSpecifications, setDetailsSpecifications] = useState([]);
  const [finalSpecifications, setFinalSpecifications] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showChoice, setShowChoice] = useState(true);
  const [cdcType, setCdcType] = useState('');
  const [filteredFlexible, setFilteredFlexible] = useState([]);
  const [isGoodPractice, setIsGoodPractice] = useState(true);

  console.log(isGoodPractice, 'isGoodPractice in SpecificationFlow');
  console.log(filteredFlexible, 'filteredFlexible in SpecificationFlow');

  const handleSaveSpecification = () => {
    replace({
      pathname: '/specifications',
      state: {
        recipe,
        specification: detailsSpecifications
      }
    });
  };

  const handleGoodPractice = (value) => {
    setIsGoodPractice(value);
  }

  console.log(detailsSpecifications, ' detailsSpecifications');
  console.log(detailsSpecifications.goodPractice, ' detailsSpecifications.goodPractice');

  const finishFlexible = async (values) => {
    values.cdcType = cdcType;
    await new Promise(r => setTimeout(r, 1000));
    await setDetailsSpecifications(values);
    // setFinalSpecifications(true);
  };

  const finishOthers = (values) => {
    setDetailsSpecifications(values);
    setFinalSpecifications(true);
  };

  const onFinish = async result => {
    await sendSpecification(recipe, detailsSpecifications, result);
    setIsModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCdcType = (type) => {
    setCdcType(type);
    setShowChoice(false);
  };

  const handleFilteredFlexible = (flexible) => {
    setFilteredFlexible(flexible);
  };

  function specificationType() {
    return (
      <Row justify="center" type="flex">
        <Space wrap align="start" size="large" style={{ marginTop: '20px' }}>
          <Button type="primary" icon={<PlusOutlined />} size="large" onClick={() => handleCdcType('other')}>Achats matériels hors flexibles</Button>
          <Button type="primary" icon={<PlusOutlined />} size="large" onClick={() => handleCdcType('flexible')}>Achats flexibles</Button>
          <Button icon={<MinusOutlined />} size="large" onClick={() => setSpecifications(false)}>Annuler</Button>
        </Space>
      </Row>
    );
  }

  const handleCancel = () => {
    setCdcType('');
    setShowChoice(true);
  };

  return (
    <>
      <ModalForm Form={SendCDC} onFinish={onFinish} handleOk={handleOk} isModalVisible={isModalVisible} />
      <PageHeader
        style={{ border: '1px solid #d9d9d9' }}
        title="Cahier des charges"
        breadcrumb={(
          <Breadcrumb
            items={[
              ['Accueil', '/'],
              ['Cahier des charges'],
            ]}
          />
        )}
        subTitle={`issu de votre recette ${name}`}
      />
      {officialTextsHead()}
      <Row justify="center">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Title level={4}>Gestion des migrations</Title>
          <Paragraph style={{ marginTop: '20px' }}>
            {SIMULANTS_LIST_TEXT}
            <Text editable={{ tooltip: false, onChange: setCustomRecipeName }}>
              {customRecipeName}
            </Text>
          </Paragraph>
          <Paragraph style={{ marginTop: '20px' }}>
            {OFFICIALTEXTSCONTENT}
            {getCodeHtml(recipe?.ingredients)}
          </Paragraph>
          {showChoice && specificationType()}
          {!finalSpecifications && cdcType === 'flexible' && _.isEmpty(detailsSpecifications) && (
            <Specifications
              recipe={recipe}
              finish={finishFlexible}
              setSpecifications={setSpecifications}
              cancel={handleCancel}
              setFilteredFlexible={handleFilteredFlexible}
              setIsGoodPractice={handleGoodPractice}
            />
          )}
          {!finalSpecifications && cdcType === 'other' && _.isEmpty(detailsSpecifications) && (
            <OtherSpecifications
              recipe={recipe}
              finish={finishOthers}
              setSpecifications={setSpecifications}
            />
          )}
          {finalSpecifications && (
            <>
            {cdcType === 'flexible' && (
              <FinalSpecification
                details={detailsSpecifications}
                handleReturnDetails={() => setSpecifications(false)}
                handleSendMail={showModal}
              />
            )}
              <Row justify="center">
                <Space align="start" size="small" style={{ marginTop: '20px' }}>
                  <Col>
                    <DownLoadPDF
                      recipeIngredient={recipe?.ingredients}
                      detailsSpecification={detailsSpecifications}
                      id={detailsSpecifications.name}
                      recipe={customRecipeName}
                    />
                  </Col>
                  <Col>
                    <Tooltip title="Confidentialité garantie">
                      <Button type="primary" onClick={() => handleSaveSpecification()}>Enregistrer ce cahier des charges</Button>
                    </Tooltip>
                  </Col>
                </Space>
              </Row>
              <Row justify="center">
                <Space align="start" size="small" style={{ marginTop: '20px' }}>
                  {cdcType === 'flexible' && (
                  <Col>
                    <Tooltip title="Confidentialité garantie">
                      <Button type="primary" onClick={showModal}>Obtenir un devis</Button>
                    </Tooltip>
                  </Col>
                  )}
                  <Col>
                    <Button type="primary" onClick={() => setSpecifications(false)}>Retour</Button>
                  </Col>
                </Space>
              </Row>
            </>
          )}
          {!finalSpecifications
          && cdcType === 'flexible'
          && isGoodPractice
          && !_.isEmpty(detailsSpecifications)
          && !_.isEmpty(filteredFlexible)
          && (
            <CostingForm
              recipe={recipe}
              specification={detailsSpecifications}
              filteredFlexibleFeatures={filteredFlexible}
              setFinalSpecifications={setFinalSpecifications}
            />
          )}
          {!finalSpecifications
          && cdcType === 'flexible'
          && !isGoodPractice
          && !_.isEmpty(detailsSpecifications)
          && (
            <Result
              status="info"
              title="Les informations ne nous permettent pas de proposer un chiffrage en ligne"
              subTitle="Vous pourrez faire une demande de devis par email depuis le détail de votre cahier des charges
              en cliquant sur le bouton ci-dessous."
              extra={(
                <Button
                  onClick={() => setFinalSpecifications(true)}
                  type="primary"
                >
                  Afficher les détails du cahier des charges
                </Button>
              )}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

SpecificationFlow.propTypes = {
  recipe: PropTypes.shape({
    name: PropTypes.string,
    ingredients: PropTypes.arrayOf(PropTypes.shape({
      ingredient: PropTypes.string,
      themes: PropTypes.string,
      condition: PropTypes.string,
    }))
  }),
  history: PropTypes.shape({
    replace: PropTypes.func
  }),
  setSpecifications: PropTypes.func
};

export default SpecificationFlow;
